import { useAuth } from '../auth/AuthProvider';
import { logoutAll } from '../api/auth';

export default function LogoutButton() {
  const { clearAuth } = useAuth();

  const handleLogoutAll = async () => {
    try {
      await logoutAll();
    } catch (err) {
      console.error('Logout all failed:', err);
    } finally {
      await clearAuth();
    }
  };

  return <button onClick={handleLogoutAll}>Logout-All</button>;
}
